// src/components/Marker.jsx
import React, { useState, useEffect } from "react";

const Marker = (props) => {
  // Detect screen size so we can enlarge the icon/click area on smaller devices
  const [isSmallDevice, setIsSmallDevice] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallDevice(window.innerWidth < 480);
    };

    // Check initial size and listen for any window resizes
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function focusOnMarker(latitude, longitude, mobileMapRef, mapRef) {
    if (mobileMapRef.current) {
      mobileMapRef.current.focusOnMarker(latitude, longitude, mapRef);
    }
  }

  return (
    <i
      className="fas fa-map-marker-alt"
      style={{
        marginLeft: "8px",
        cursor: "pointer",
        color: "#ff6b6b",
        // Larger icon and extra padding (hit-box) on small devices:
        fontSize: isSmallDevice ? "24px" : "16px",
        padding: isSmallDevice ? "12px" : "0",
      }}
      title="Focus on Map"
      onClick={() =>
        focusOnMarker(props.coordY, props.coordX, props.mobileMapRef, props.mapRef)
      }
    ></i>
  );
};

export default Marker;